import "./styles/destination.css"
import moon from './assets/destination/image-moon.webp';
import mars from './assets/destination/image-mars.webp';
import europa from './assets/destination/image-europa.webp';
import titan from './assets/destination/image-titan.webp';
import { useState } from 'react';
import useFetch from './usefetch';

const Destination = () => {
    const [planet,setPlanet] = useState(0)
    const { dataDestination, error } = useFetch('data.json')
    
    const planetList = [moon,mars,europa,titan]



    const checkedInput = (e) => {
        const inputList = document.querySelectorAll('input[type="checkbox"]');

        inputList.forEach((input) => {
            input.checked = false;
            input.parentElement.classList.remove('active');
        })

        e.target.parentElement.classList.add('active')
    }


    return (
        <>
            {error && <div>{error}</div>}
            {dataDestination && 
        <div className="destinationsPage">
            <section className="destination">
                <div className="imageS">
                    <p className="tagLine"><span className="tag">01</span>  PICK YOUR DESTINATION</p>
                    <div className="imageCont">
                        <img src={planetList[planet]} alt="" />
                    </div>
                </div>
                <div className="infoDev">
                    <div className="destNav">
                        <label htmlFor="moon" className="active">MOON
                                    <input type="checkbox" name="moon" id="moon" value="0" onChange={e => {
                                        checkedInput(e)
                                        setPlanet(e.target.value)
                                    }} />
                        </label>
                        <label htmlFor="mars">MARS
                                    <input type="checkbox" name="mars" id="mars" value="1" onChange={e => {
                                        checkedInput(e)
                                        setPlanet(e.target.value)
                                    }} />
                        </label>
                        <label htmlFor="europa">EUROPA
                                    <input type="checkbox" name="europa" id="europa" value="2" onChange={e => {
                                        checkedInput(e)
                                        setPlanet(e.target.value)
                                    }} />
                        </label>
                        <label htmlFor="titan">TITAN
                                    <input type="checkbox" name="titan" id="titan" value="3" onChange={e => {
                                        checkedInput(e)
                                        setPlanet(e.target.value)
                                    }} />
                        </label>
                    </div>
                    <section className="planetInfo">
                                <h1 className="planetName">{(dataDestination[planet].name).toUpperCase()}</h1>
                        <article className="aboutPlanet">
                            <p>
                                        {dataDestination[planet].description}
                           </p>
                        </article>
                        <hr />
                        <aside>
                            <div className="distance">
                                <span className="head">AVG. DISTANCE</span>
                                        <span className="data">{dataDestination[planet].distance}</span>
                            </div>
                            <div className="time">
                                <span className="head">EST. TRAVEL TIME</span>
                                        <span className="data">{dataDestination[planet].travel}</span>
                            </div>
                        </aside>
                    </section>
                </div>
            </section>
            </div>}
        </>
    )
}
 
export default Destination;